// @ts-nocheck

import { createReducer } from 'Helpers/redux'
import { Shopper } from 'Types/index'
import {
  UPDATE_SCHEDULED_CAMPAIGN,
  CHANGE_CAMPAIGN_GENRE,
  GET_CURATORS_LIST,
  SET_CHECKOUT_STEP,
  CHECK_COUPON,
  REMOVE_COUPON,
  GET_BLUESNAP_PFTOKEN,
  GET_VAULTED_SHOPPER,
  SUBMIT_BLUESNAP_PAYMENT,
  SET_CURATORS_LIST_IS_EMPTY,
  GET_CAMPAIGN_BUDGET_RANGE,
  UPDATE_CAMPAIGN,
  GET_AUDIENCE_TIKTOK,
  CHANGE_CAMPAIGN,
} from '../actions/scheduleActions'

const initialState = {
  scheduledCampaign: {},
  matchingResult: null,
  curators: [],
  country: null,
  step: 1,
  coupon: null,
  pfToken: null,
  curatorsListIsEmpty: false,
  budgetRange: null,
  audience: {},
  shopper: {
    paymentSources: {
      creditCardInfo: [],
    },
  },
  isUpdateCampaignLoading: false,
}

const handlers = {
  [GET_AUDIENCE_TIKTOK.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    audience: payload,
  }),

  [UPDATE_CAMPAIGN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    matchingResult: payload,
  }),
  [CHANGE_CAMPAIGN.REQUEST]: prevState => ({
    ...prevState,
    isUpdateCampaignLoading: true,
  }),
  [CHANGE_CAMPAIGN.FAILURE]: prevState => ({
    ...prevState,
    isUpdateCampaignLoading: false,
  }),
  [CHANGE_CAMPAIGN.SUCCESS]: prevState => ({
    ...prevState,
    isUpdateCampaignLoading: false,
  }),

  [CHANGE_CAMPAIGN_GENRE.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    curators: payload.curators,
    scheduledCampaign: payload.campaign,
  }),
  [GET_CURATORS_LIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    curators: payload.curators,
    country: payload.country,
  }),
  [UPDATE_SCHEDULED_CAMPAIGN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    scheduledCampaign: payload,
    coupon: null,
  }),
  [SET_CHECKOUT_STEP]: (prevState, { payload }) => ({
    ...prevState,
    step: payload,
  }),
  [CHECK_COUPON.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    coupon: payload.coupon,
  }),
  [REMOVE_COUPON]: prevState => ({
    ...prevState,
    coupon: null,
  }),
  [GET_BLUESNAP_PFTOKEN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    pfToken: payload.pfToken,
  }),
  [GET_VAULTED_SHOPPER.SUCCESS]: (
    prevState,
    {
      payload,
    }: {
      payload: {
        shopper: Shopper
      }
    }
  ) => ({
    ...prevState,
    shopper: payload,
  }),
  [SUBMIT_BLUESNAP_PAYMENT.SUCCESS]: prevState => ({
    ...prevState,
    pfToken: null,
  }),
  [SET_CURATORS_LIST_IS_EMPTY]: (prevState, { payload }) => ({
    ...prevState,
    curatorsListIsEmpty: payload,
  }),
  [GET_CAMPAIGN_BUDGET_RANGE.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    budgetRange: payload,
  }),
  [GET_CAMPAIGN_BUDGET_RANGE.FAILURE]: (prevState, { payload }) => ({
    ...prevState,
    budgetRange: {
      min: 0,
      max: 0,
      error: payload,
    },
  }),
  [GET_VAULTED_SHOPPER.FAILURE]: (
    prevState,
    {
      payload,
    }: {
      payload: {
        shopper: Shopper
      }
    }
  ) => ({
    ...prevState,
    shopper: { creditCards: [] },
  }),
}

export default createReducer(initialState, handlers)
